import {promisify} from '../promisify';
import type {NoopType} from '../type';

import {setAfterCommitQueue, setIdleCallbackQueue, setTimeoutQueue} from './timers';

// To avoid getting into the style rendering frame right away
const TIMEOUT_DELAY_MS = 25;

const spawnSetTimeout = <T>(cb: NoopType<T>) => promisify(cb, setTimeoutQueue, TIMEOUT_DELAY_MS);
const spawnAfterCommitTask = <T>(cb: NoopType<T>) => promisify(cb, setAfterCommitQueue);
const spawnIdleCallback = <T>(cb: NoopType<T>) =>
    promisify(cb, setIdleCallbackQueue, TIMEOUT_DELAY_MS);

const delayFnCallbacks = {
    afterCommit: spawnAfterCommitTask,
    deferred: spawnSetTimeout,
    idle: spawnIdleCallback,
};

type KeysType = keyof typeof delayFnCallbacks;

/**
 * Callback spawning a new task in the next tick depending on the priority
 * deferred - a deferred task with a delay;
 * idle - a lazy task, will be executed only if there are no other tasks for more than 50 ms;
 * afterCommit - execution after applying changes at home aka commit
 * @returns - result of callback execution
 */
export const spawnPriorityTask = <T>(cb: NoopType<T>, mode: KeysType = 'idle') =>
    delayFnCallbacks[mode](cb) as Promise<Awaited<T>>;
